var _circle, _g, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTournamentLeagueTypeNewGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9453,
    cy: 30.9717,
    r: 24.7632,
    stroke: "#30B36B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47854_166136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.84 23.8665H36.8663V22.2875C36.8663 21.8138 36.5505 21.498 36.0768 21.498H27.3926C26.9189 21.498 26.6032 21.8138 26.6032 22.2875V23.8665H24.6295C24.1558 23.8665 23.84 24.1823 23.84 24.6559V29.3928C23.84 29.6296 23.9979 29.8665 24.1558 30.0244L29.3663 33.7349C29.6032 33.9717 29.84 34.1296 30.0768 34.1296H30.9453V36.498H26.9979V38.077H36.4716V36.498H32.5242V34.1296H33.3926C33.6295 34.1296 33.8663 33.9717 34.0242 33.8138L39.2347 30.1033C39.4716 29.9454 39.5505 29.7086 39.5505 29.4717V24.6559C39.6295 24.1823 39.3137 23.8665 38.84 23.8665ZM25.4189 25.4454H26.6032V28.6033C26.6032 28.7612 26.6032 28.8402 26.6821 28.998L27.5505 30.498L25.4189 28.998V25.4454ZM30.5505 32.5507L28.1821 28.3665V23.077H35.2874V28.3665L32.9189 32.5507H30.5505ZM38.0505 28.998L35.9189 30.498L36.7874 28.998C36.8663 28.9191 36.8663 28.7612 36.8663 28.6033V25.4454H38.0505V28.998Z",
    fill: "#30B36B"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1558,
    cy: 5.70852,
    r: 4.73684,
    fill: "#30B36B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.68215,
    cy: 30.9717,
    r: 4.73684,
    fill: "#30B36B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1558,
    cy: 56.2348,
    r: 4.73684,
    fill: "#30B36B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.2085,
    cy: 30.9717,
    r: 4.73684,
    fill: "#30B36B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.1033,
    cy: 13.6033,
    r: 4.73684,
    fill: "#30B36B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.1033,
    cy: 48.3401,
    r: 4.73684,
    fill: "#30B36B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2085,
    cy: 48.3401,
    r: 4.73684,
    fill: "#30B36B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2085,
    cy: 13.6033,
    r: 4.73684,
    fill: "#30B36B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47854_166136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9474,
    height: 18.9474,
    fill: "white",
    transform: "translate(22.261 19.9191)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournamentLeagueTypeNewGreen);
export default __webpack_public_path__ + "static/media/tournament-league-type-new-green.fcdb3aee45c9e018f8b1b99ba0e1f856.svg";
export { ForwardRef as ReactComponent };